// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"66d82117","513":"7eb03f15","545":"a72ad120"}[chunkId] + ".chunk.js";
};